export const eventCreationSteps = {
  generalInformation: 'general',
  locationCover: 'location',
  eventSettings: 'settings',
  preview: 'preview',
} as const

export type EventCreationStep =
  (typeof eventCreationSteps)[keyof typeof eventCreationSteps]

export const eventCreationWorkflow: EventCreationStep[] = [
  'general',
  'location',
  'settings',
  'preview',
]
